// Formulari de filtres del llistat de contractes (sector, estat, dates, CUPS/CIF); usat a ContratosList.
import React, { useState } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import Select from 'react-select';
import './ContratosFilter.css';

const ContratosFilter = ({ onFilter, onExport, initialFilters = {} }) => {

    const statusOptions = [
        { value: "activa", label: "Activa" },
        { value: "baixa", label: "Baja" },
        { value: "cancelada", label: "Cancelada" },
        { value: "esborrany", label: "Borrador" },
        { value: "impagament", label: "Impaga" },
        { value: "modcontractual", label: "Mod. Contractual Abierta" },
        { value: "pendent", label: "Pendiente" },
        { value: "tall", label: "Alta" },
        { value: "validar", label: "Validar" },
        { value: "saliente", label: "Saliente" }
    ];

    // Converteix el valor de text d'initialFilters.estado al format { value, label }
    const getInitialStatus = () => {
        if (initialFilters.estado) {
            const option = statusOptions.find(o => o.value === initialFilters.estado);
            return option ? [option] : [];
        }
        return [];
    };

    const [poliza, setPoliza] = useState(initialFilters.poliza || "");
    const [cliente, setCliente] = useState(initialFilters.cliente || "");
    const [cups, setCups] = useState(initialFilters.cups || "");
    const [nif, setNif] = useState(initialFilters.nif || "");
    const [sector, setSector] = useState(initialFilters.sector || "");
    const [status, setStatus] = useState(getInitialStatus());
    const [altaFrom, setAltaFrom] = useState(initialFilters.altaFrom || "");
    const [altaTo, setAltaTo] = useState(initialFilters.altaTo || "");
    const [bajaFrom, setBajaFrom] = useState(initialFilters.bajaFrom || "");
    const [bajaTo, setBajaTo] = useState(initialFilters.bajaTo || "");

    // Sync internal state when initialFilters changes (e.g. restoration from parent)
    React.useEffect(() => {
        setPoliza(initialFilters.poliza || "");
        setCliente(initialFilters.cliente || "");
        setCups(initialFilters.cups || "");
        setNif(initialFilters.nif || "");
        setSector(initialFilters.sector || "");
        setStatus(getInitialStatus());
        setAltaFrom(initialFilters.altaFrom || "");
        setAltaTo(initialFilters.altaTo || "");
        setBajaFrom(initialFilters.bajaFrom || "");
        setBajaTo(initialFilters.bajaTo || "");
    }, [initialFilters]);


    const sectorOptions = [
        { value: "", label: "Todos" },
        { value: "electrico", label: "Electricidad" },
        { value: "gas", label: "Gas" }
    ];

    // Envia tots els filtresal pare (ContratosList) per executar la cerca
    const handleFilter = (e) => {
        e.preventDefault();
        onFilter({ poliza, cliente, cups, nif, sector, status, altaFrom, altaTo, bajaFrom, bajaTo });
    };

    // Buida tots els camps i notifica el pare amb filtres buits
    const handleReset = () => {
        const resetFilters = {
            poliza: "",
            cliente: "",
            nif: "",
            cups: "",
            sector: "",
            status: [],
            altaFrom: "",
            altaTo: "",
            bajaFrom: "",
            bajaTo: ""
        };
        setPoliza("");
        setCliente("");
        setNif("");
        setCups("");
        setSector("");
        setStatus([]);
        setAltaFrom("");
        setAltaTo("");
        setBajaFrom("");
        setBajaTo("");
        onFilter(resetFilters);
    };

    // Bloqueja el botó Buscar si algun rang de dates és invàlid
    const isFormValid = () => {
        return (isDateRangeValid(altaFrom, altaTo) && isDateRangeValid(bajaFrom, bajaTo));
    }

    // Un rang és vàlid si està buit o si dateFrom <= dateTo
    const isDateRangeValid = (dateFrom, dateTo) => {
        const isRangeEmpty = (!dateFrom && !dateTo);
        const isRangeValid = (dateFrom && dateTo) ? new Date(dateFrom) <= new Date(dateTo) : isRangeEmpty;

        return (isRangeValid || isRangeEmpty)
    }

    return (
        <div className="detail-card filter-card p-3 pb-2 border-0 shadow-sm rounded-4">
            <Form onSubmit={handleFilter}>
                <Row className="g-3 gy-4">
                    <Col md={3}>
                        <Form.Group>
                            <Form.Label className="text-muted small fw-bold text-uppercase">Sector</Form.Label>
                            <Form.Select
                                className="form-control rounded-3 border-light shadow-sm bg-light"
                                value={sector}
                                onChange={(e) => setSector(e.target.value)}
                            >
                                {sectorOptions.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>

                    <Col md={3}>
                        <Form.Group>
                            <Form.Label className="text-muted small fw-bold text-uppercase">Estado</Form.Label>
                            <Select
                                classNamePrefix="react-select"
                                options={statusOptions}
                                isMulti
                                value={status}
                                placeholder="Seleccionar..."
                                onChange={(e) => setStatus(e)}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        borderRadius: '0.5rem',
                                        border: '1px solid #f8f9fa',
                                        boxShadow: '0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)',
                                        backgroundColor: '#f8f9fa'
                                    }),
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                }}
                            />
                        </Form.Group>
                    </Col>

                    <Col md={3}>
                        <Form.Group>
                            <Form.Label className="text-muted small fw-bold text-uppercase">Nº contrato</Form.Label>
                            <Form.Control
                                type="text"
                                className="rounded-3 border-light shadow-sm bg-light"
                                value={poliza}
                                onChange={(e) => setPoliza(e.target.value)}
                            />
                        </Form.Group>
                    </Col>

                    <Col md={3}>
                        <Form.Group>
                            <Form.Label className="text-muted small fw-bold text-uppercase">Cliente</Form.Label>
                            <Form.Control
                                type="text"
                                className="rounded-3 border-light shadow-sm bg-light"
                                value={cliente}
                                onChange={(e) => setCliente(e.target.value)}
                            />
                        </Form.Group>
                    </Col>

                    <Col md={3}>
                        <Form.Group>
                            <Form.Label className="text-muted small fw-bold text-uppercase">Alta desde</Form.Label>
                            <Form.Control
                                type="date"
                                className="rounded-3 border-light shadow-sm bg-light"
                                value={altaFrom}
                                onChange={(e) => setAltaFrom(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={3}>
                        <Form.Group>
                            <Form.Label className="text-muted small fw-bold text-uppercase">Alta hasta</Form.Label>
                            <Form.Control
                                type="date"
                                className="rounded-3 border-light shadow-sm bg-light"
                                value={altaTo}
                                onChange={(e) => setAltaTo(e.target.value)}
                            />
                            {!isDateRangeValid(altaFrom, altaTo) && (
                                <Form.Text className="text-danger small">
                                    Rango inválido.
                                </Form.Text>
                            )}
                        </Form.Group>
                    </Col>

                    <Col md={3}>
                        <Form.Group>
                            <Form.Label className="text-muted small fw-bold text-uppercase">Baja desde</Form.Label>
                            <Form.Control
                                type="date"
                                className="rounded-3 border-light shadow-sm bg-light"
                                value={bajaFrom}
                                onChange={(e) => setBajaFrom(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={3}>
                        <Form.Group>
                            <Form.Label className="text-muted small fw-bold text-uppercase">Baja hasta</Form.Label>
                            <Form.Control
                                type="date"
                                className="rounded-3 border-light shadow-sm bg-light"
                                value={bajaTo}
                                onChange={(e) => setBajaTo(e.target.value)}
                            />
                            {!isDateRangeValid(bajaFrom, bajaTo) && (
                                <Form.Text className="text-danger small">
                                    Rango inválido.
                                </Form.Text>
                            )}
                        </Form.Group>
                    </Col>

                    <Col md={6}>
                        <Form.Group>
                            <Form.Label className="text-muted small fw-bold text-uppercase">CUPS / CIF</Form.Label>
                            <div className="d-flex gap-2">
                                <Form.Control
                                    type="text"
                                    placeholder="CUPS"
                                    className="rounded-3 border-light shadow-sm bg-light"
                                    value={cups}
                                    onChange={(e) => setCups(e.target.value)}
                                />
                                <Form.Control
                                    type="text"
                                    placeholder="CIF"
                                    className="rounded-3 border-light shadow-sm bg-light"
                                    value={nif}
                                    onChange={(e) => setNif(e.target.value)}
                                />
                            </div>
                        </Form.Group>
                    </Col>
                </Row>

                <div className="d-flex justify-content-end align-items-center mt-4 gap-2 border-top pt-3">
                    <Button
                        variant="outline-secondary"
                        className="rounded-pill px-4 fw-bold"
                        disabled={!isFormValid()}
                        onClick={handleReset}
                    >
                        Limpiar filtros
                    </Button>
                    <Button
                        variant="outline-secondary"
                        className="rounded-pill px-4 fw-bold"
                        disabled={!isFormValid()}
                        onClick={onExport}
                    >
                        Exportar
                    </Button>

                    <Button
                        variant="primary"
                        className="rounded-pill px-4 fw-bold shadow-sm"
                        type="submit"
                        disabled={!isFormValid()}>
                        Buscar Contratos
                    </Button>
                </div>
            </Form>
        </div>
    );
};

export default ContratosFilter;